var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9499 23.8098C15.3858 26.1719 17.6832 26.1288 18.3007 26.1288H25.6955L16.9724 15.5391C12.9519 15.7042 10.8196 18.2888 11.2576 19.3657L13.9571 23.8098H13.9499Z",
    fill: "url(#paint0_linear_4326_7960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2506 19.3725C11.2506 19.3725 11.0137 18.8197 11.0137 18.1736C11.0137 15.7541 13.1532 14.3684 15.5942 13.873L16.9726 15.5459C12.9521 15.711 10.8198 18.2956 11.2578 19.3725H11.2506Z",
    fill: "url(#paint1_linear_4326_7960)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6177 11.5111C10.9418 11.5111 8.19922 12.1142 8.19922 13.5572C8.19922 14.0885 8.36435 14.548 8.81666 15.3521L11.2577 19.3654C11.2577 19.3654 11.0208 18.8126 11.0208 18.1665C11.0208 15.747 13.1602 14.3613 15.6013 13.866C16.3049 13.7224 17.03 13.6506 17.7408 13.6506C18.3367 13.6506 18.8967 13.6793 19.3274 13.8372C19.0761 12.9111 18.4013 11.5039 14.6249 11.5039L14.6177 11.5111Z",
    fill: "url(#paint2_linear_4326_7960)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94714 9.00513C5.95945 10.6636 6.33278 11.0728 8.73791 11.08H13.3328L6.99329 3.07487C5.59329 1.34462 4.78919 1.02872 3.50406 1H0.0722656L4.94714 9.00513Z",
    fill: "url(#paint3_linear_4326_7960)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.648 25.5613C27.648 25.8772 27.3968 26.1285 27.0809 26.1285C26.765 26.1285 26.5137 25.8772 26.5137 25.5613C26.5137 25.2454 26.765 24.9941 27.0809 24.9941C27.3968 24.9941 27.648 25.2526 27.648 25.5613ZM26.6285 25.5613C26.6285 25.8126 26.8296 26.0136 27.0809 26.0136C27.3321 26.0136 27.5332 25.8126 27.5332 25.5613C27.5332 25.31 27.3321 25.109 27.0809 25.109C26.8296 25.109 26.6285 25.31 26.6285 25.5613ZM27.0665 25.5972H27.0162V25.827H26.9157V25.267H27.0809C27.2101 25.267 27.2819 25.3316 27.2819 25.4321C27.2819 25.547 27.1885 25.5757 27.167 25.5829L27.3034 25.8341H27.1885L27.0593 25.6044L27.0665 25.5972ZM27.0521 25.5254C27.1383 25.5254 27.1814 25.4895 27.1814 25.4321C27.1814 25.3747 27.1383 25.3388 27.0521 25.3388C27.0234 25.3388 27.0162 25.3388 27.0091 25.3388V25.5182C27.0091 25.5182 27.0306 25.5182 27.0521 25.5182V25.5254Z",
    fill: "#36495A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4326_7960",
    x1: 18.4442,
    y1: 15.2591,
    x2: 18.4442,
    y2: 31.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E81B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#DA1920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C3171C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A31316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7B0E0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#780E0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4326_7960",
    x1: 11.0137,
    y1: 16.6156,
    x2: 16.9655,
    y2: 16.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69231D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8D2821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B12E26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C83228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1342A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4326_7960",
    x1: 10.3602,
    y1: 15.747,
    x2: 16.9941,
    y2: 11.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E7EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D4DBDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A4B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96A7B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4326_7960",
    x1: 6.70612,
    y1: 12.3938,
    x2: 6.70612,
    y2: 1.12205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C2F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#164586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0D72AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0592CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#01A5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ADE4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAa);
export default __webpack_public_path__ + "static/media/AA.6b248f06b12557a7f8ebdaa59ecf2acb.svg";
export { ForwardRef as ReactComponent };